import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, Renderer2 } from "@angular/core";

@Directive({
	selector: "[click.prevent]",
})
export class ClickPreventDirective {
	@Output("click.prevent") preventDefaultEvent = new EventEmitter();

	constructor() {}
	@HostListener("click", ["$event"])
	onHostElementClick(ev: Event) {
		ev.preventDefault();
		this.preventDefaultEvent?.emit?.(...arguments);
	}
}
